"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _storage = require("@/utils/storage.js");
var _util = require("@/utils/util");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'layoutBreadcrumb',
  data: function data() {
    return {
      breadcrumbList: [],
      routeSplit: [],
      routeSplitFirst: '',
      routeSplitIndex: 1
    };
  },
  computed: {
    breadCrumbList: function breadCrumbList() {
      var menuList = this.$store.state.user.menuList;
      var openMenus = (0, _util.getMenuopen)(this.$route, menuList);
      var allMenuList = (0, _util.R)(menuList, []);
      var selectMenu = [];
      if (allMenuList.length > 0) {
        openMenus.forEach(function (i) {
          allMenuList.forEach(function (a) {
            if (i === a.path) {
              selectMenu.push(a);
            }
          });
        });
      }
      return selectMenu;
    },
    crumbPast: function crumbPast() {
      var that = this;
      var menuList = that.$store.state.user.menuList;
      var allMenuList = (0, _util.R)(menuList, []);
      var selectMenu = [];
      if (allMenuList.length > 0) {
        allMenuList.forEach(function (a) {
          if (that.$route.path === a.path) {
            selectMenu.push(a);
          }
        });
      }
      return selectMenu;
    },
    // 获取布局配置信息
    getThemeConfig: function getThemeConfig() {
      return this.$store.state.themeConfig.themeConfig;
    },
    // 动态设置经典、横向布局不显示
    isShowBreadcrumb: function isShowBreadcrumb() {
      var _this$$store$state$th = this.$store.state.themeConfig.themeConfig,
        layout = _this$$store$state$th.layout,
        isBreadcrumb = _this$$store$state$th.isBreadcrumb;
      if (layout === 'transverse' || layout === 'classic') {
        return 'none';
      } else {
        return isBreadcrumb ? '' : 'none';
      }
    },
    isShowcrumb: function isShowcrumb() {
      var layout = this.$store.state.themeConfig.themeConfig.layout;
      if (layout === 'transverse' || layout === 'classic') {
        return false;
      } else {
        return true;
      }
    },
    collapseShow: function collapseShow() {
      return ['defaults', 'columns'].includes(this.$store.state.themeConfig.themeConfig.layout);
    }
  },
  mounted: function mounted() {
    var _this = this;
    // 确保菜单数据加载完成后再初始化
    if (this.$store.state.user.menuList && this.$store.state.user.menuList.length > 0) {
      this.initRouteSplit(this.$route.path);
    } else {
      // 如果菜单还没加载，监听菜单变化
      var unwatch = this.$watch(function () {
        return _this.$store.state.user.menuList;
      }, function (newVal) {
        if (newVal && newVal.length > 0) {
          _this.initRouteSplit(_this.$route.path);
          unwatch(); // 取消监听
        }
      });
    }
  },
  methods: {
    // breadcrumb 当前项点击时
    onBreadcrumbClick: function onBreadcrumbClick(v) {
      console.log(v);
      var redirect = v.redirect,
        path = v.path;
      this.$router.push(path);
    },
    // breadcrumb icon 点击菜单展开与收起
    onThemeConfigChange: function onThemeConfigChange() {
      if (this.$store.state.themeConfig.themeConfig.layout == 'columns' && !this.$store.state.user.childMenuList.length && this.$store.state.themeConfig.themeConfig.isCollapse) {
        return;
      }
      this.$store.state.themeConfig.themeConfig.isCollapse = !this.$store.state.themeConfig.themeConfig.isCollapse;
      this.setLocalThemeConfig();
    },
    // 存储布局配置
    setLocalThemeConfig: function setLocalThemeConfig() {
      _storage.Local.remove('JavaPlatThemeConfigPrev');
      _storage.Local.set('JavaPlatThemeConfigPrev', this.$store.state.themeConfig.themeConfig);
    },
    // 递归设置 breadcrumb
    getBreadcrumbList: function getBreadcrumbList(arr) {
      var _this2 = this;
      arr.map(function (item) {
        _this2.routeSplit.map(function (v, k, arrs) {
          if (_this2.routeSplitFirst === item.path) {
            _this2.routeSplitFirst += "/".concat(arrs[_this2.routeSplitIndex]);
            _this2.breadcrumbList.push(item);
            _this2.routeSplitIndex++;
            if (item.children) _this2.getBreadcrumbList(item.children);
          }
        });
      });
    },
    // 当前路由分割处理
    initRouteSplit: function initRouteSplit(path) {
      // 检查菜单数据是否存在
      if (!this.$store.state.user.menuList || this.$store.state.user.menuList.length === 0) {
        return;
      }
      this.breadcrumbList = [{
        path: '/',
        meta: {
          title: this.$store.state.user.menuList[0].title,
          icon: this.$store.state.user.menuList[0].icon
        }
      }];
      //   this.routeSplit = path.split('/');
      //   this.routeSplit.shift();
      this.routeSplitFirst = path;
      this.routeSplitIndex = 1;
      this.getBreadcrumbList(this.$store.state.user.menuList);
    }
  },
  // 监听路由的变化
  watch: {
    $route: {
      handler: function handler(newVal) {
        // this.initRouteSplit(newVal.path);
        var menuList = this.$store.state.user.menuList;
        var openMenus = (0, _util.getMenuopen)(newVal, menuList);
        var allMenuList = (0, _util.R)(menuList, []);
        var selectMenu = [];
        if (allMenuList.length > 0) {
          openMenus.forEach(function (i) {
            allMenuList.forEach(function (a) {
              if (i === a.path) {
                selectMenu.push(a);
              }
            });
          });
        }
      },
      deep: true
    }
  }
};